<template>
    <div class="delete">
        <img class="empty-img" src='https://ali2.a.kwimgs.com/udata/pkg/kmovie/kyh5/empty.5806e0c1a8a60a4b.png' />
        <div class="empty-text">
            此模板已被创作者删除，回到剪同款页发现更多精彩
        </div>
        <OpenTag
            openUrl="kwaiying://mv"
            logType="delete-btn"
            :id='id'
            :shareKey="deleteKey"
            :wxShareKey="wxShareKey"
        >
            <div class="empty-btn">
                打开快影app
            </div>
        </OpenTag>
        <OpenTag
            :openUrl="`kwaiying://krn?bundleId=profile&componentName=profile-guest&userId=${userId}&from=mvShare`"
            logType="delete-btn"
            :id='id'
            :shareKey="deleteKey"
            :wxShareKey="wxShareKey"
        >
            <div class="empty-btn empty-btn-border">
                查看作者其他模板
            </div>
        </OpenTag>
    </div>
</template>

<script>
import OpenTag from './OpenTag.vue';

export default {
    props: {
        openUrl: {
            type: String,
            default: '',
        },
        userId: {
            type: String,
            default: '',
        },
        id: {
            type: String,
            default: '',
        },
    },
    components: {
        OpenTag,
    },
    data() {
        return {
            deleteKey:'MV_SHARE_H5_DELETE_BTN',
            wxShareKey:'MV_SHARE_H5_USE_WX_LAUNCH',
        };
    },
  }
</script>

<style scoped lang="less">
.delete {
    display: flex;
    width: 100%;
    height: 100%;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .empty-img {
        width: 1.6rem;
        height: 1.6rem;
    }
    .empty-text {
        font-size: 0.24rem;
        font-family: PingFangSC;
        line-height: 0.36rem;
        color: rgba(255, 255, 255, 0.4);
        margin-bottom: 0.08rem;
        margin-top: 0.12rem;
    }
    .empty-btn {
        width: 2.64rem;
        text-align: center;
        justify-content: center;
        align-items: center;
        font-size: 0.26rem;
        font-weight: 600;
        font-family: PingFangSC;
        color: rgba(255, 255, 255, 0.9);
        background-color: rgba(255, 255, 255, 0.2);
        padding: 0.3rem 0 0.3rem 0;
        border-radius: 0.52rem;
        margin-top: 0.4rem;
    }
}
.empty-btn-border {
    background-color: transparent !important;
    color: rgba(255, 255, 255, 0.4) !important;
    border:  0.02rem solid rgba(255, 255, 255, 0.2);
}
</style>
